import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Marquee from "react-fast-marquee";
import BlogCard from '../components/BlogCard';
import ProductCard from '../components/ProductCard';
import SpecialProduct from '../components/SpecialProduct';
import Container from '../components/Container'
import { services } from "../utils/Data";
import { useDispatch, useSelector } from 'react-redux';
import { getAllBlogs } from '../features/blogs/blogSlice';
import moment from 'moment';
import { getAllProducts } from '../features/products/productSlice';
import ProductCardPopu from '../components/ProductCardPopu';



const Home = () => {
  const productState=useSelector((state)=>state?.product.product)
  const blogState=useSelector((state)=> state?.blog?.blog)
  console.log(productState)
  const dispatch=useDispatch()
  useEffect(()=>{
      getBlogs()
      getProducts()
  },[])
  const getBlogs=()=>{
      dispatch(getAllBlogs())
  }

  const getProducts=()=>{
    dispatch(getAllProducts())

  }

  return (
    <>
      <Container class1="home-wrapper-1 py-5">
        <div className="row">
          <div className="col-6">
            <div className="main-banner position-relative ">
              <img
                src="images/main-banner-1.jpg"
                className="img-fluid rounded-3"
                alt="main banner"
              />
              <div className="main-banner-content position-absolute">
                <h4>SUPERCHARGED FOR PROS.</h4>
                <h5>iPad S13+ Pro.</h5>
                <p>From $999.00 or $41.62/mo.</p>
                <Link className="button">BUY NOW</Link>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex flex-wrap gap-10 justify-content-between align-items-center">
              <div className="small-banner position-relative">
                <img
                  src="images/catbanner-01.jpg"
                  className="img-fluid rounded-3"
                  alt="main banner"
                />
                <div className="small-banner-content position-absolute">
                  <h4>Best Sake</h4>
                  <h5>iPad S13+ Pro.</h5>
                  <p>
                    From $999.00 <br /> or $41.62/mo.
                  </p>
                </div>
              </div>
              <div className="small-banner position-relative">
                <img
                  src="images/catbanner-02.jpg"
                  className="img-fluid rounded-3"
                  alt="main banner"
                />
                <div className="small-banner-content position-absolute">
                  <h4>NEW ARRIVAL</h4>
                  <h5>But IPad Air</h5>
                  <p>
                    From $999.00 <br /> or $41.62/mo.
                  </p>
                </div>
              </div>
              <div className="small-banner position-relative ">
                <img
                  src="images/catbanner-03.jpg"
                  className="img-fluid rounded-3"
                  alt="main banner"
                />
                <div className="small-banner-content position-absolute">
                  <h4>NEW ARRIVAL</h4>
                  <h5>But IPad Air</h5>
                  <p>
                    From $999.00 <br /> or $41.62/mo.
                  </p>
                </div>
              </div>
              <div className="small-banner position-relative ">
                <img
                  src="images/catbanner-04.jpg"
                  className="img-fluid rounded-3"
                  alt="main banner"
                />
                <div className="small-banner-content position-absolute">
                  <h4>NEW ARRIVAL</h4>
                  <h5>But IPad Air</h5>
                  <p>
                    From $999.00 <br /> or $41.62/mo.
                  </p>
                </div>
              </div>


            </div>
          </div>
        </div>
      </Container>

      <Container class1="home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="services d-flex align-items-center justify-content-between">
              {services?.map((i, j) => {
                return (
                  <div className='d-flex align-items-center gap-15' key={j}>
                    <img src={i.image} alt="services" />
                    <div>
                      <h6>
                        {i.title}
                      </h6>
                      <p className="mb-0">{i.tagline}</p>
                    </div>
                  </div>

                );
              })}
            </div>
          </div>
        </div>
      </Container>

      <Container class1="home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="categories d-flex justify-content-between flex-wrap align-items-center">
              <div className='d-flex gap align-iteems-center'>
                <div >
                  <h6>Music & Gaming</h6>
                  <p>10 items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>

              <div className='d-flex gap align-iteems-center'>
                <div >
                  <h6>Cameras</h6>
                  <p>10 items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>

              <div className='d-flex gap align-iteems-center'>
                <div >
                  <h6>Smart tv</h6>
                  <p>10 items</p>
                </div>
                <img src="images/tv.jpg" alt="camera" />
              </div>

              <div className='d-flex gap align-iteems-center'>
                <div >
                  <h6>Smart watches</h6>
                  <p>10 items</p>
                </div>
                <img src="images/headphone.jpg" alt="camera" />
              </div>

              <div className='d-flex gap align-iteems-center'>
                <div >
                  <h6>Music & Gaming</h6>
                  <p>10 items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>

              <div className='d-flex  align-iteems-center'>
                <div >
                  <h6>Cameras</h6>
                  <p>10 items</p>
                </div>
                <img src="images/camera.jpg" alt="camera" />
              </div>

              <div className='d-flex  align-iteems-center'>
                <div >
                  <h6>Smart tv</h6>
                  <p>10 items</p>
                </div>
                <img src="images/tv.jpg" alt="camera" />
              </div>

              <div className='d-flex gap-30 align-iteems-center'>
                <div >
                  <h6>Smart watches</h6>
                  <p>10 items</p>
                </div>
                <img src="images/headphone.jpg" alt="camera" />
              </div>


            </div>
          </div>
        </div>
      </Container>

      <Container class1="featured-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">
              Featured Collection
            </h3>
          </div>
          {productState && productState?.map((item,index)=>{
            if(item.tags==="featured"){
              return(  <ProductCardPopu
                key={index} 
                id={item?._id}
                title={item?.title} 
                brand={item?.brand} 
                totalrating={item?.totalrating.toString()} 
                price={item?.price} 
                sold={item?.sold}
                quantity={item?.quantity}
                description={item?.description}
                images={item?.images}
                
                />)
            }
           
          })}
        

        </div>
      </Container>

      <Container class1="famous-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-3">
            <div className="famous-card  position-relative">
              <img src="images/famous-1.webp" className='img-fluid' alt="famous" />
              <div className="famous-content position-absolute">
                <h5>
                  Big Screen
                </h5>
                <h6>
                  Smart Watch Series
                </h6>
                <p>From $399 or 16/mo for 24 mo.</p>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div className="famous-card  position-relative">
              <img src="images/famous-2.webp" className='img-fluid' alt="famous" />
              <div className="famous-content position-absolute">
                <h5 className='text-dark'>
                  Studio Display
                </h5>
                <h6 className='text-dark'>
                  600 nits brightness
                </h6>
                <p className='text-dark'>27 inch 5k </p>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div className="famous-card  position-relative">
              <img src="images/famous-3.webp" alt="famous" className='img-fluid' />
              <div className="famous-content position-absolute">
                <h5 className='text-dark'>
                  Smartphones
                </h5>
                <h6 className='text-dark'>
                  Smart Phone 13pro
                </h6>
                <p className='text-dark'>Now in green From $999 or $14 62/mo for 24 note</p>
              </div>
            </div>
          </div>


          <div className="col-3">
            <div className="famous-card  position-relative">
              <img src="images/famous-4.webp" alt="famous" className='img-fluid' />
              <div className="famous-content position-absolute">
                <h5 className='text-dark'>
                  Home Speakers
                </h5>
                <h6 className='text-dark'>
                  Room Filling Sound
                </h6>
                <p className='text-dark'>From $699 or $99 month . for 12 month</p>
              </div>
            </div>
          </div>

        </div>

      </Container>

      <Container class1="special-wrapper py-5 home-wrapper-2">
        <div className="row">
        <div className="col-12">
            <h3 className="section-heading">
              Special Product
            </h3>
          </div>
          {productState && productState?.map((item,index)=>{
            if(item.tags==="special"){
              return(  <SpecialProduct 
                key={index} 
                id={item?._id}
                title={item?.title} 
                brand={item?.brand} 
                totalrating={item?.totalrating.toString()} 
                price={item?.price} 
                sold={item?.sold}
                quantity={item?.quantity}
                />)
            }
           
          })}
        
         

        </div>
      </Container>

      <Container class1="popular-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">
              Our Popular Products
            </h3>
          </div>


        </div>
        <div className="row">
        {productState && productState?.map((item,index)=>{
            if(item.tags==="popular"){
              return(  <ProductCardPopu
                key={index} 
                id={item?._id}
                title={item?.title} 
                brand={item?.brand} 
                totalrating={item?.totalrating.toString()} 
                price={item?.price} 
                sold={item?.sold}
                quantity={item?.quantity}
                description={item?.description}
                images={item?.images}
                
                />)
            }
           
          })}

        </div>
      </Container>

      <Container class1="marquee-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="marquee-inner-wrapper card-wrapper">
              <Marquee className='d-flex'>
                <div className="mx-4 w-25">
                  <img src="" alt="" />
                </div>

                <div className="mx-4 w-25">
                  <img src="" alt="" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-01.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-02.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-03.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-04.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-05.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-06.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-07.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-05.png" alt="brand" />
                </div>

                <div className="mx-4 w-25">
                  <img src="images/brand-08.png" alt="brand" />
                </div>
              </Marquee>
            </div>
          </div>
        </div>
      </Container>

      <Container class1="blog-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">
              Our Latest Blogs
            </h3>
          </div>

        </div>
        <div className="row">
        { blogState?
                            blogState?.map((item,index)=>{
                               if(index<3){
                                return(
                                  <div className="col-3 mb-3" key={index}>
                                  <BlogCard id={item?._id} title={item?.title} description={item?.description} image={item?.images[0]?.url} date={moment(item?.createdAt).format('MMMM Do YYYY, h:mm a')}/>
                                  </div>
                              )
                               }
                            }):[]
                        }
        </div>
      </Container>




    </>
  )
}

export default Home